<template>
  <BalloonDropdown
    v-if="isTooltip && !isSP"
    class="d-businessLabel"
    :position="tooltipPosition"
    :triggers="['hover']"
    :width="tooltipWidth"
  >
    <a
      href="javascript:;"
      slot="trigger"
    >
      <DLabel
        class="d-businessLabel_label"
        :text-color="textColor"
        background-color=""
        :has-divider="hasDivider"
      >
        <span class="d-businessLabel_text">ビジネス利用</span>
      </DLabel>
    </a>

    <div class="d-businessLabel_hoverWrapper">
      <span class="d-businessLabel_hoverText">ビジネス購入アカウントのユーザーです。</span>
      <div class="d-businessLabel_hoverLink">
        <a
          :href="$coconala.helpURL('/articles/360020926033')"
          target="_blank"
          rel="noopener"
        >
          詳しくはこちら
          <CoconalaIcon
            name="chevron-right"
            size="14px"
          />
        </a>
      </div>
    </div>
  </BalloonDropdown>
  <div
    v-else
    class="d-businessLabel"
  >
    <DLabel
      class="d-businessLabel_label"
      :text-color="textColor"
      background-color=""
      :has-divider="hasDivider"
    >
      <span class="d-businessLabel_text">ビジネス利用</span>
    </DLabel>
  </div>
</template>

<script>
import BalloonDropdown from '~/components/molecules/BalloonDropdown'
import DLabel from '~/components/atoms/DS2/DLabel/DLabel'

import { mapGetters } from 'vuex'

const DBusinessLabel = {
  name: 'DBusinessLabel',
  props: {
    /** ツールチップ */
    isTooltip: {
      type: Boolean,
      default: false
    },
    tooltipWidth: {
      type: String,
      default: '288px'
    },
    tooltipPosition: {
      type: String,
      default: 'is-bottom-right'
    },
    /** ビジネスラベル */
    hasDivider: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: 'BusinessNavy700'
    }
  },
  components: {
    BalloonDropdown,
    DLabel
  },
  computed: {
    ...mapGetters('ui', ['isSP'])
  }
}

export default DBusinessLabel
</script>
<style lang="scss" scoped>
.d-businessLabel {
  display: inline-flex;
  &_text {
    letter-spacing: 0.05em;
    font-size: 13px;
    line-height: 19px;
  }
  &_hoverWrapper {
    display: flex;
    padding: 8px 16px;
    height: 60px;

    flex-flow: column;
  }
  &_hoverText {
    letter-spacing: 0.02em;
    font-size: 12px;
    line-height: 19px;
  }
  &_hoverLink {
    margin-top: 6px;
    margin-left: auto;
    letter-spacing: 0.02em;
    font-size: 12px;
    line-height: 19px;
    a {
      color: $color-white;
    }
  }
  /deep/ .dropdown {
    &-trigger {
      &::after {
        border: 0;
        background: #5f5f5f; // 吹き出しの矢印部分をなじませるため色を直指定;
      }
    }
  }
  /deep/ .dropdown-menu {
    left: -100px;

    .dropdown-content {
      border: 0;
      background: rgba(51, 51, 51, 0.8);
      color: $color-white;
      cursor: default;
    }
  }
}
</style>
